import { addRoofSlabSection, deleteRoofSlabSectionByUuid, findRoofSlabSectionsByprojectUuid } from "@/api/building/roof-slab-section";
import { RoofSlabSection } from "@/commons/interface/building/roof-slab-section";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import RoofSlabDisplayItem from "./roof-slab-item/display";
import RoofSlabEditItem from "./roof-slab-item/edit";
import genUUID from "@/commons/utils/gen-uuid";
import './index.less';
import SideBarTool from "@/commons/components/side-bar-tool";
import { SideBarBtnType } from "@/commons/enums/side-bar-btn-type";
import TnMessage from "@/commons/widget/message";

const EditChild = forwardRef(RoofSlabEditItem);


// 屋面板侧边栏
export default function RoofSlab() {

    const { projectUuid } = useParams(); // 路由参数，项目id
    const [list, setList] = useState<RoofSlabSection[]>([]); // 屋面板板型列表
    const [selectedItem, setSelectedItem] = useState<RoofSlabSection>(); // 当前被选择的屋面板
    const [editingItem, setEditingItem] = useState<RoofSlabSection>(); // 当前正在编辑状态的屋面板
    const editRef = useRef(null);

    useEffect(() => {
        if (!projectUuid) return;
        getRoofSlabSections();
    }, [projectUuid]) // 项目id变化时，获得屋面板板型列表

    // 根据项目id获得屋面板板型列表
    const getRoofSlabSections = () => {
        findRoofSlabSectionsByprojectUuid(projectUuid).then(res => {
            let list: RoofSlabSection[] = res.data || [];
            setList(list);
        }).catch(err => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("获得屋面板板型列表失败")
            }
        })
    }

    // 点击了添加按钮，新增一个屋面板
    const onAdd = () => {
        // 生成一个临时uuid
        const uuid = genUUID();
        let newItem: RoofSlabSection = {
            name: '',
            uuid: uuid,
            projectUuid: projectUuid,
            entity: null,
        }
        // 添加屋面板
        addRoofSlabSection(projectUuid, newItem).then(res => {
            setList([...list, newItem]);
            setSelectedItem(newItem);
            setEditingItem(newItem);
        }).catch(err => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("新增屋面板失败")
            }
        })
    }

    // 点击了编辑按钮，编辑当前选择的屋面板
    const onEdit = () => {
        if (!selectedItem) {
            TnMessage.warning("请先选中要编辑的屋面板")
            return;
        }
        if (selectedItem?.uuid == editingItem?.uuid) {
            // 当前正在编辑态，再点击编辑按钮，名称又重回编辑状态
            if (editRef.current) {
                editRef.current.handleEditName();
            }
        }
        setEditingItem(selectedItem);
    }

    // 点击了删除按钮，删除当前选择的屋面板
    const onDelete = () => {
        if (!selectedItem) {
            TnMessage.warning("请先选中要删除的屋面板")
            return;
        }
        deleteRoofSlabSectionByUuid(selectedItem.uuid).then(res => {
            TnMessage.success("删除成功");
            // 列表中删除当前选择的屋面板
            let newList = list.filter(item => item.uuid != selectedItem.uuid);
            setList(newList);
            // 当前选择的置空
            setSelectedItem(null);
        }).catch((err) => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("删除失败");
            }
        })
    }


    return (
        <div className="roof-slab-container">
            <SideBarTool onAddBtnClick={onAdd} onEditBtnClick={onEdit} onDeleteBtnClick={onDelete}
                activeBtnList={[SideBarBtnType.ADD, SideBarBtnType.EDIT, SideBarBtnType.DELETE]} />
            <div className="main-content">
                <div className="panel-title">屋面板</div>
                <div className="list-main">
                    {list.map((item, index) => (
                        <div key={index} onClick={() => setSelectedItem(item)}>
                            {index != 0 && <div className="divider"></div>}
                            {item.uuid == editingItem?.uuid && <EditChild ref={editRef} item={item}
                                onSaveName={(name) => {
                                    item.name = name;
                                    setList([...list]);
                                }}
                                onSaveDraw={(entity) => {
                                    item.entity = entity;
                                    setList([...list]);
                                    setSelectedItem(null);
                                    setEditingItem(null);
                                }} />}
                            {item.uuid != editingItem?.uuid && <RoofSlabDisplayItem item={item} selected={selectedItem?.uuid == item.uuid} />}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}